// The paywall's legal sentence, rendered with its two links. Shared by the
// web checkout panel (ProPurchasePanel) and the Google Play hand-off panel
// (AndroidPlayPurchasePanel), whose sentences differ only in where to cancel.
import { Fragment, type ReactNode } from 'react'

const LEGAL_LINKS: Record<string, string> = { 0: '/terms', 1: '/privacy' }

/**
 * The paywall's legal sentence with its two links: `<0>` is the Terms, `<1>`
 * the Privacy Policy, opening in a NEW TAB (see the comment at the call).
 * The same `<n>...</n>` convention as components/results/tagged.tsx's
 * renderTagged, inlined because this panel is in the entry bundle: importing
 * that module from here split it into a shared chunk that every prerendered
 * page then preloaded. An unknown or unclosed tag renders its text plainly.
 */
export function legalWithLinks(text: string): ReactNode[] {
  const out: ReactNode[] = []
  const re = /<(\d+)>([\s\S]*?)<\/\1>/g
  let last = 0
  let m: RegExpExecArray | null
  while ((m = re.exec(text))) {
    if (m.index > last) out.push(text.slice(last, m.index))
    const href = LEGAL_LINKS[m[1]]
    out.push(
      href ? (
        <a key={out.length} href={href} target="_blank" rel="noopener noreferrer" className="text-gray-400 underline hover:text-gray-300">{m[2]}</a>
      ) : (
        <Fragment key={out.length}>{m[2]}</Fragment>
      ),
    )
    last = m.index + m[0].length
  }
  if (last < text.length) out.push(text.slice(last).replace(/<\/?\d+>/g, ''))
  return out
}

